import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate('/');
  };

  // Define styles as JavaScript objects
  const styles = {
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      background: 'linear-gradient(360deg, rgb(255, 128, 89), rgb(255, 255, 255))',
      textAlign: 'center',
      zIndex: 100,
      position: 'fixed',
      width: '100vw',
    },
    content: {
      maxWidth: '600px',
      padding: '20px',
      background: 'rgba(255, 255, 255, 0.8)',
      borderRadius: '10px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    },
    heading: {
      fontSize: '2.5rem',
      marginBottom: '20px',
      color: '#333',
    },
    paragraph: {
      fontSize: '1.2rem',
      marginBottom: '30px',
      color: '#666',
    },
    button: {
      fontSize: '1rem',
      color: '#fff',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
    },
    buttonHover: {
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={styles.heading}>Oops! You are on the wrong page.</h1>
        <p style={styles.paragraph}>It seems like the page you are looking for doesn't exist.</p>
        <button
          onClick={goToHome}
          style={styles.button}
        >
          Take Me Home
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;